import { useState, useEffect } from "react";
import Loader from "./Loader.jsx";

const Specialmeeting = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/splmeetings.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        setMeetings(data.splmeetings);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };
  return (
    <div className="gallery-container">
      <h1>சிறப்புச் சந்திப்புகள்</h1>
      <div className="image-grid1">
        {meetings.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img src={img} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <div className="fullscreen-image-container">
            <img src={selectedImage} alt="Full screen" />
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Specialmeeting;
